import configurationSettingService from "reduxStore/service/configurationSettingService";
import strings from "translate/language";
import { errorToast, unAuthorizedError, successToast } from "utils/httpClient";
import {
  GET_CONFIGURATION_SETTING_DETAIL,
  GET_PRIVACY_POLICY,
  UPDATE_PRIVACY_POLICY,
  UPDATE_SETTING_DETAIL,
} from "../types";

export const configurationSettingDetail = (item) => async (dispatch) => {
  try {
    const res = await configurationSettingService.getConfigurationSettingDetail(
      item
    );

    if (res.data.status === 200) {
      dispatch({
        type: GET_CONFIGURATION_SETTING_DETAIL,
        payload: res.data,
      });
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const configurationSettingUpdate = (item) => async (dispatch) => {
  try {
    const res = await configurationSettingService.updateSettingDetail(item);

    if (res.data.status === 200) {
      dispatch({
        type: UPDATE_SETTING_DETAIL,
        payload: res.data,
      });
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const getPrivacyPolicy = (item) => async (dispatch) => {
  try {
    const res = await configurationSettingService.getPrivacyPolicy(item);

    if (res.data.status === 200) {
      dispatch({
        type: GET_PRIVACY_POLICY,
        payload: res.data,
      });
    }
  } catch (e) {
    // const { response = strings.initialError } = e;
    // unAuthorizedError(response.data);
  }
};
export const updatePrivacyPolicy = (item) => async (dispatch) => {
  try {
    const res = await configurationSettingService.updatePrivacyPolicy(item);

    if (res.data.status === 200) {
      dispatch({
        type: UPDATE_PRIVACY_POLICY,
        payload: res.data,
      });
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
